import { ApprovalsService } from '@/services/approvals/approvals.service';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormArray } from '@angular/forms';
import { MunicipalLicence, ValidityTypes } from '../../../../../../interfaces/approvals/approvals';
import { normalize } from '@/utils/normalizeString';
import { validityDayValidator } from './addtition-info.validator';
import { mustHaveOneRecord } from '@/validators/mustHaveOneRecord';
import { TableType } from '@/interfaces/common/common.interface';

@Component({
  selector: 'app-additional-info',
  templateUrl: './additional-info.component.html',
  styleUrls: ['./additional-info.component.css'],
})
export class AdditionalInfoComponent implements OnInit {
  @Input() validityTypes: ValidityTypes[] = [];

  showDaysTemporaryDaysSelected: boolean = false
  municipalLicenses: MunicipalLicence[] = [];
  parseLicenseMunicipalTypeA: MunicipalLicence[] = [];
  parseLicenseMunicipalTypeBtoF: MunicipalLicence[] = [];

  // FORMULARIO DE  LICENCIA VALIDACION

  @Input() additionalInformationForm = new FormGroup({
    validity: new FormControl(0),
    validityTemporaryDays: new FormControl(30),
    comentaryTemporaryDays: new FormControl(''),
    municipalLicenses: new FormControl([], [mustHaveOneRecord()]),
    restrictionDriver: new FormControl('', []),
  }, [validityDayValidator('validity', 'validityTemporaryDays', 1)]);

  _municipalLicensesControl = new FormArray([]);

  get municipalLicensesControl(): FormArray {
    return this._municipalLicensesControl as FormArray;
  }
  get municipalLicensesControls(): FormControl[] {
    return this.municipalLicensesControl.controls as FormControl[];
  }
  get validityTemporaryDaysControl(): FormControl {
    return this.additionalInformationForm.controls.validityTemporaryDays as FormControl;
  }

  get shouldShowDaysTemporaryDaysSelected(): boolean {
    const temporalValidity = this.validityTypes.find((validityType) => normalize(validityType.name) === normalize('TEMPORAL'));
    if (temporalValidity) {
      return this.additionalInformationForm.controls.validity.value === temporalValidity.id;
    }
    return false;
  }
  get comentaryTemporaryDays() {
    return this.additionalInformationForm.controls.comentaryTemporaryDays as FormControl;
  }
  get restrictionDriverNote() {
    return this.additionalInformationForm.controls.restrictionDriver as FormControl;
  }
  get validityTemporaryDays() {
    return this.additionalInformationForm.controls.validityTemporaryDays as FormControl;
  }

  get daysTextLength() {
    const { value } = this.additionalInformationForm.controls.validityTemporaryDays;
    if (typeof value !== 'undefined' && value !== null) {
      return value.toString().length;
    }
    return 0;
  }

  municipalLicensesControlCreated = false;

  constructor(private serviceApproval: ApprovalsService) {
  }

  ngOnInit(): void {
    this.municipalLicensesControl.valueChanges.subscribe({
      next: (values: boolean[]) => {
        const thereIsACheckedLicense = values.some((value) => value);
        if (thereIsACheckedLicense) {
          const checkedLicenses: any = [];
          const checkedIndexes = values.map((value, index) => (value ? index : undefined)).filter((index) => index !== undefined);
          const municipalLicensesViewOrdered = [...this.parseLicenseMunicipalTypeA, ...this.parseLicenseMunicipalTypeBtoF];
          checkedIndexes.map((index) => {
            checkedLicenses.push((municipalLicensesViewOrdered[index as number] as TableType).id);
          });
          this.additionalInformationForm.controls.municipalLicenses.setValue(checkedLicenses);
        }
        else {
          const checkedLicenses: any = [];
          this.additionalInformationForm.controls.municipalLicenses.setValue(checkedLicenses);
        }
      },
    });

    const formControls = this.additionalInformationForm.controls;
    formControls.validity.valueChanges.subscribe({
      next: () => {
        formControls.validityTemporaryDays.setValue(30);
        formControls.comentaryTemporaryDays.setValue('');
      },
    });

    this.getLicensesType();
  }

  getLicensesType() {
    this.serviceApproval.getLicensesType()
      .subscribe({
        next: (res) => {
          this.municipalLicensesControlCreated = false;
          const sorteredLicenses = res.sort((a, b) => {
            if (a.name > b.name) {
              return 1;
            }
            if (a.name < b.name) {
              return -1;
            }
            return 0;
          });
          this.municipalLicenses = sorteredLicenses;
          this.parseLicenseMunicipalTypeA = sorteredLicenses.filter((typeA) => typeA.name.length >= 2);

          this.parseLicenseMunicipalTypeBtoF = res.filter((typeA) => typeA.name.length < 2);

          // const municipalLicensesControl = this.additionalInformationForm.controls.municipalLicenses as FormArray;

          for (let index = this.municipalLicensesControl.controls.length - 1; index >= 0; index--) {
            this.municipalLicensesControl.removeAt(index);
          }

          res.map(() => {
            this.municipalLicensesControl.push(new FormControl(false));
          });

          this.municipalLicensesControlCreated = true;
        },

      });
  }

}
